import React from 'react'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src'
import {BottomCTA} from 'components/Accommodation/Offers/BottomCTA'
import {reviewMessages} from 'components/Reviews/ReviewMessages'
import {getGuestReviewsOverlayVisibility} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {
  OverlayPage,
  OverlayPageContent,
  OverlayPageFooter
} from '@vio/atlas/OverlayPage'
import {PopUp} from '@vio/atlas/PopUp'
import {Text} from '@vio/atlas/Text'

import {ConditionalReviews} from '../AccommodationView/Mobile/ConditionallyRenderedSections/ConditionalReviews'

interface Props {
  hotel: ContentHotel | undefined
}
const HeaderText = styled(Text)`
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const TitleBarContent = () => {
  const {formatMessage} = useIntl()

  return (
    <HeaderText variant="titleM" align="center">
      {formatMessage(reviewMessages.guestReviews)}
    </HeaderText>
  )
}

export const GuestReviewsOverlayPage = ({hotel}: Props) => {
  const {isDesktop} = useDeviceLayout()

  const dispatch = useDispatch()
  const isOpen = useSelector(getGuestReviewsOverlayVisibility)

  const onClose = () => {
    dispatch(hideOverlay())
  }

  if (isDesktop)
    return (
      <PopUp
        width={1000}
        isOpen={isOpen}
        closeAction={onClose}
        navBarProps={{
          centerContent: <TitleBarContent />,
          withDivider: true
        }}
      >
        <ConditionalReviews hotel={hotel} isFullLayout mountedOnOverlay />
      </PopUp>
    )

  return (
    <OverlayPage
      navBarProps={{
        centerContent: <TitleBarContent />
      }}
      isOpen={isOpen}
      onClose={onClose}
      dataId="guestReviewsOverlayContent"
    >
      <OverlayPageContent>
        <ConditionalReviews hotel={hotel} isFullLayout mountedOnOverlay />
      </OverlayPageContent>
      <OverlayPageFooter>
        <BottomCTA
          hotelId={hotel?.objectID}
          sourceComponent="MobileHotelGuestReviewsTopOfferCTA"
        />
      </OverlayPageFooter>
    </OverlayPage>
  )
}
